import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import axios from 'axios';
import { store } from "./app/store.js"
import App from './App';
import { installLanggananWatcher } from './componen/langganan/LanggananNotice';
import { tandaiModeAplikasi } from './utils/modeAplikasi';
import { jsPDF } from 'jspdf';
import { pasangCatatEkspor } from './utils/catatEkspor';

axios.defaults.withCredentials = true;
tandaiModeAplikasi();
installLanggananWatcher();
pasangCatatEkspor(jsPDF); // PDF yang diunduh dicatat di Log Aktivitas


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
